<template>
  <div id="intro-2" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Vendor Tracking</h3>
      </div>

      <div class="intro-box__content">
        <p>Our app will automatically track your vendors by either the vendor
          name field or by a tag
          on the product. Which would you like to use?</p>

        <div class="intro-box__actions">
          <div class="form-field">
            <div class="grid-x grid-padding-x">
              <div class="cell auto text-right">
                <label
                  :class="['radio-choice', chosen === 'Vendor Name' ? 'active' : '']"
                  @click="choose('Vendor Name')">Vendor Name</label>
              </div>

              <div class="cell auto text-left">
                <label
                  :class="['radio-choice', chosen === 'Product Tag' ? 'active' : '']"
                  @click="choose('Product Tag')">Product Tag</label>
              </div>
            </div>
          </div>
        </div>

        <div class="intro-box__action-helper" v-if="chosen === 'Vendor Name'">
          <p>Will use the vendor name field on products for tracking.</p>
        </div>

        <div class="intro-box__action-helper"
             v-if="chosen === 'Product Tag'">
          <p>Will use a tag on products for tracking based off of a prefix. We
            will use whatever is after the prefix so if your prefix is vendor_
            then products with a tag of
            <nobr>"vendor_John Doe"</nobr>
            will
            associate all sales to
            <nobr>"John Doe".</nobr>
          </p>

          <div class="grid-x grid-padding-x">
            <div class="cell large-4">
              <label>Tag Prefix</label>
            </div>

            <div class="cell auto">
              <input
                id="vendor_tag"
                class="medium-input"
                name="product-tag-prefix"
                type="text" placeholder="vendor_"
                :value="vendor_tag">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <button :class="['button--wide', chosen === null ? 'disabled': '']"
              @click="changeStep()">
        Continue
      </button>
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [client],
  data: function () {
    return {
      chosen: null,
      vendor_tag: ''
    }
  },
  methods: {
    choose (choice) {
      this.chosen = choice
    },
    async change () {
      if (this.chosen === 'Product Tag') {
        let meta = this.$store.state.metas.vendor_product_tag_prefix
        this.vendor_tag = document.getElementById('vendor_tag').value
        meta.meta_value = this.vendor_tag
        await this.$store.dispatch('updateMeta', meta)
      }

      await this.$store.dispatch('updateSetting', {
        tracking_type: this.chosen
      })
    },
    changeStep () {
      this.change()

      this.$emit('changeStep', true)
    }
  },
  created () {
    this.vendor_tag = this.$store.state.metas.vendor_product_tag_prefix.meta_value
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step2.vue